import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { DateStyle, Locale, Page } from "@beyondrealityapp/core/shared/constants";
import GoalAchievedDialogView from "./GoalAchievedDialogView";
import {
  completionColors,
  confettiRain,
} from "../../../utils/goal/goalCompletion";
import { hideGoalAchieved } from "../../../features/goalAchieved";
import type { RootState } from "../../../config/store";

const GoalAchievedDialogController: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const goal = useSelector((state: RootState) => state.goalAchieved.goal);

  useEffect(() => {
    if (goal) {
      confettiRain(completionColors(theme));
    }
  }, [goal, theme]);

  const startedOn = goal?.startedAt
    ? new Date(goal.startedAt).toLocaleDateString(Locale.EN, {
        dateStyle: DateStyle.LONG,
      })
    : "";

  const onClose = () => {
    dispatch(hideGoalAchieved());
  };

  const onWriteAbout = () => {
    if (goal) {
      navigate(`/${Page.JOURNAL}/-1`, {
        state: { title: `Completed: ${goal.title}` },
      });
    }
    dispatch(hideGoalAchieved());
  };

  return (
    <GoalAchievedDialogView
      goal={goal}
      startedOn={startedOn}
      onWriteAbout={onWriteAbout}
      onClose={onClose}
    />
  );
};

export default GoalAchievedDialogController;
